import { useEffect } from 'react'
import { useEditSession } from '@/core/store/editSession'
import { selectCanRedo, selectCanUndo } from '@/core/store/selectors'

function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false
  return target.isContentEditable
    || target.closest('[contenteditable="true"]') !== null
    || target.tagName === 'INPUT'
    || target.tagName === 'TEXTAREA'
    || target.tagName === 'SELECT'
}

export function useUndoRedoShortcuts(): void {
  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (isEditableTarget(event.target)) return
      const key = event.key.toLowerCase()
      const undoRequested = (event.ctrlKey || event.metaKey) && key === 'z' && !event.shiftKey
      const redoRequested = ((event.ctrlKey || event.metaKey) && key === 'z' && event.shiftKey)
        || (event.ctrlKey && key === 'y')
      if (!undoRequested && !redoRequested) return

      event.preventDefault()
      const state = useEditSession.getState()
      if (undoRequested && selectCanUndo(state)) state.undo()
      if (redoRequested && selectCanRedo(state)) state.redo()
    }
    window.addEventListener('keydown', onKeyDown)
    return () => window.removeEventListener('keydown', onKeyDown)
  }, [])
}
